import RetailerStore from './RetailerStore'

export default RetailerStore
